<section class="users-area ptb-100 jarallax" data-jarallax='{"speed": 0.3}'>
    <div class="container">
        <div class="users-content" *ngFor="let Content of usersContent;">
            <h2>{{Content.title}}</h2>
            <p>{{Content.paragraph}}</p>
            <a routerLink="/{{Content.buttonLink}}" class="default-btn">{{Content.buttonText}}<span></span></a>
        </div>
    </div>
</section>